"use strict";

var _construct = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/construct");

var _toConsumableArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _mongoObject = _interopRequireDefault(require("mongo-object"));

var _extend = _interopRequireDefault(require("extend"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var SimpleSchemaGroup =
/*#__PURE__*/
function () {
  function SimpleSchemaGroup() {
    _classCallCheck(this, SimpleSchemaGroup);

    for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
      definitions[_key] = arguments[_key];
    }

    this.definitions = definitions.map(function (definition) {
      if (_mongoObject.default.isBasicObject(definition)) return (0, _extend.default)(true, {}, definition);

      if (definition instanceof RegExp) {
        return {
          type: String,
          regEx: definition
        };
      }

      return {
        type: definition
      };
    });
  }

  _createClass(SimpleSchemaGroup, [{
    key: "clone",
    value: function clone() {
      return _construct(SimpleSchemaGroup, _toConsumableArray(this.definitions));
    }
  }, {
    key: "extend",
    value: function extend(otherGroup) {
      // We extend based on index being the same. No better way I can think of at the moment.
      this.definitions = this.definitions.map(function (def, index) {
        var otherDef = otherGroup.definitions[index];
        if (!otherDef) return def;
        return (0, _extend.default)(true, {}, def, otherDef);
      });
    }
  }, {
    key: "singleType",
    get: function get() {
      return this.definitions[0].type;
    }
  }]);

  return SimpleSchemaGroup;
}();

var _default = SimpleSchemaGroup;
exports.default = _default;
module.exports = exports.default;
module.exports.default = exports.default;